import React from "react";
import "./style.css";
// This file exports the Input, TextArea, Select and FormBtn components

export function Input(props) {
  return (
    <div className="form-group">
      <input className="form-control" {...props} />
    </div>
  );
}

export function Select(props) {
  const listItems = props.list.map(item => 
    <option key={item.name} value={item.name}>{item.name}</option>
  );
  return (
    <div className="form-group">
      <select className="form-control" name={props.name} onChange={props.changed}>
        {listItems}
      </select>
    </div>
  );
}

export function TextArea(props) {
  return (
    <div className="form-group">
      <textarea className="form-control" rows="6" {...props} />
    </div>
  );
}

export function FormBtn(props) {
  return (
    <button {...props} style={{ float: "right", marginBottom: 10 }} className="btn btn-lg">
      {props.children}
    </button>
  );
}
